var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.banner),attrs:{"id":"banner"}},[(_vm.html_content !== undefined && _vm.html_content.length)?_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.html_content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }